import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSliderModule } from '@angular/material/slider';
import { LeftSideMenuComponent } from './layout-components/left-side-menu/left-side-menu.component';
import { FooterComponent } from './layout-components/footer/footer.component';
import { MainContentComponent } from './layout-components/main-content/main-content.component';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { CommonDataService } from './common/services/common-data.service';
import { HomeComponent } from './components/home/home.component';
import { LoginComponent } from './components/Login/Login.component';
import { RightOverlayComponent } from './layout-components/right-overlay/right-overlay.component';
import { ClickOutsideDirective } from './common/directives/click-outside.directive';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProvideFeedbackComponent } from './common/shared-components/provide-feedback/provide-feedback/provide-feedback.component';
import { LocationBreadcrumbComponent } from './common/shared-components/location-breadcrumb/location-breadcrumb.component';
import { BookmarkComponent } from './common/shared-components/bookmark/bookmark.component';
import { XBLRElementsComponent } from './common/shared-components/xblr-elements/xblr-elements.component';
import { AnnotationsComponent } from './common/shared-components/annotations/annotations.component';
import { YourAnnotationComponent } from './common/shared-components/your-annotation/your-annotation.component';
import { MatBadgeModule } from '@angular/material/badge';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ConfigurationService } from './common/services/configuration.service';
import { LoginService } from './common/services/Login.service';
import { RouteGaurdService } from './common/services/route-gaurd.service';
import { PDFBackupGaurdService } from './common/services/PDF-Backup-guard.service';
import { NgxCaptchaModule } from "ngx-captcha";
import { httpInterceptor } from './common/services/httpInterceptor'
import { ValidationService } from './common/services/validation.service';
import { NotificationComponent } from './common/shared-components/notification/notification.component';
import { MasterGlossaryComponent } from './components/master-glossary/master-glossary.component';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatExpansionModule } from '@angular/material/expansion';
import { HighlightSearchTermPipe } from './common/pipes/highlight-search-term.pipe';
import { ErrorComponent } from './common/shared-components/error/error.component';
import { DatePipe } from '@angular/common';
import { GraphqlService } from './common/services/graphql.service';
import { SharedModule } from './common/shared.module';
import { AutoFocusDirective } from './common/directives/auto-focus.directive';
import { GeneralFeedbackComponent } from './common/shared-components/general-feedback/general-feedback.component';
import { MatDialogModule } from '@angular/material/dialog';
import { ConfirmDialogComponent } from './common/shared-components/confirm-dialog/confirm-dialog.component';
import { MyHistoryComponent } from './components/my-history/my-history.component';
import { MyAnnotationsComponent } from './components/my-annotations/my-annotations.component';
import { MyBookmarkComponent } from './components/my-bookmark/my-bookmark.component';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { AboutUsComponent } from './components/about-us/about-us.component';
import { ContactUsComponent } from './components/contact-us/contact-us.component';
import { CopyrightComponent } from './components/copyright/copyright.component';
import { HelpComponent } from './components/help/help.component';
import { TermsAndConditionsComponent } from './components/terms-and-conditions/terms-and-conditions.component';
import { MatRadioModule } from '@angular/material/radio';
import { ContactSupportComponent } from './components/Login/contact-support/contact-support.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { ClearSessionsService } from './common/services/clear-sessions.service';
import { ArchiveComponent } from './common/shared-components/archive/archive.component';
import { InlineGlossaryComponent } from './common/shared-components/inline-glossary/inline-glossary.component';
import { PublicationModule } from './modules/publication/publication.module';
import { ShortTextPipe } from './common/pipes/short-text.pipe';
import { MatTabsModule } from '@angular/material/tabs';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SafeHTMLPipe } from './common/pipes/safe-html.pipe';
import { TableComponent } from './common/shared-components/table/table.component';
import { SttTableComponent } from './common/shared-components/stt-table/stt-table.component';
import { SearchComponent } from './components/search/search.component';
import { EffectiveDateComponent } from './components/effective-date/effective-date.component';
import { WhatLinksHereComponent } from './common/shared-components/what-links-here/what-links-here.component';
import { CookieComponent } from './common/shared-components/cookie/cookie.component';
import { GlossaryTermUsageComponent } from './common/shared-components/glossary-term-usage/glossary-term-usage.component';
import { GlossaryTermTopicComponent } from './common/shared-components/glossary-term-topic/glossary-term-topic.component';
import { HostListenerClickDirective } from './common/directives/host-listener-click.directive';
import { SourceTracingToolComponent } from './components/source-tracing-tool/source-tracing-tool.component';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import { RelatedContentComponent } from './common/shared-components/related-content/related-content.component';
import { UnderDevelopmentComponent } from './components/under-development/under-development.component';
import { FinalPronouncementComponent } from './components/final-pronouncement/final-pronouncement.component';
import { HelpAnnotationsComponent } from './components/help/help-annotations/help-annotations.component';
import { HelpArchivedContentComponent } from './components/help/help-archived-content/help-archived-content.component';
import { HelpBrowsingComponent } from './components/help/help-browsing/help-browsing.component';
import { HelpBookmarksComponent } from './components/help/help-bookmarks/help-bookmarks.component';
import { HelpGlossaryTermFinderComponent } from './components/help/help-glossary-term-finder/help-glossary-term-finder.component';
import { HelpMyGarsComponent } from './components/help/help-my-gars/help-my-gars.component';
import { HelpMyHistoryComponent } from './components/help/help-my-history/help-my-history.component';
import { HelpPrintingComponent } from './components/help/help-printing/help-printing.component';
import { HelpRelatedContentComponent } from './components/help/help-related-content/help-related-content.component';
import { HelpSearchingComponent } from './components/help/help-searching/help-searching.component';
import { HelpSourceTracingComponent } from './components/help/help-source-tracing/help-source-tracing.component';
import { NgxPrintModule } from 'ngx-print';
import { ImplementationGuideComponent } from './components/implementation-guide/implementation-guide.component';
import { PublicCommentComponent } from './components/public-comment/public-comment.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { BackButtonComponent } from './common/shared-components/back-button/back-button.component';
import { AcronymsComponent } from './components/acronyms/acronyms.component';
import { HelpContactusComponent } from './components/help/help-contactus/help-contactus.component';
import { HelpCopypasteComponent } from './components/help/help-copypaste/help-copypaste.component';
import { HelpShowallinonepageComponent } from './components/help/help-showallinonepage/help-showallinonepage.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { PdfhelpComponent } from './components/pdfhelp/pdfhelp.component';
import { PdflandingpageComponent } from './components/pdflandingpage/pdflandingpage.component';
import { AccessManagementComponent } from './components/access-management/access-management.component';
import { AddUserComponent } from './common/shared-components/add-user/add-user.component';
import { VideosComponent } from './components/videos/videos.component';
import { SafePipe } from './common/pipes/safe.pipe';
import { ArchiveHomeComponent } from './components/archive-home/archive-home.component';
import { UtilityService } from './common/services/utility-service';
import { RedisCacheManagementComponent } from './components/redis-cache-management/redis-cache-management.component';
import { InternalViewRouteGuardService } from './common/services/internal-view-route-guard.service';
import { InternalAdminViewRouteGuardService } from './common/services/internal-admin-view-route-guard.service';
import { CacheControlInterceptor } from './common/interceptors/cache-control.interceptor';
import { PDFBackupLandingPageComponent } from './components/pdfbackup-landing-page/pdfbackup-landing-page.component';
import { MatTreeModule } from '@angular/material/tree';


@NgModule({
  declarations: [
    AppComponent,
    LeftSideMenuComponent,
    FooterComponent,
    MainContentComponent,
    HomeComponent,
    LoginComponent,
    RightOverlayComponent,
    ClickOutsideDirective,
    ProvideFeedbackComponent,
    LocationBreadcrumbComponent,
    BookmarkComponent,
    XBLRElementsComponent,
    AnnotationsComponent,
    YourAnnotationComponent,
    NotificationComponent,
    MasterGlossaryComponent,
    HighlightSearchTermPipe,
    ErrorComponent,
    AutoFocusDirective,    
    GeneralFeedbackComponent,
    ConfirmDialogComponent,
    MyHistoryComponent,
    MyAnnotationsComponent,
    MyBookmarkComponent,
    AboutUsComponent,
    CopyrightComponent,
    ContactUsComponent,
    HelpComponent,
    HelpAnnotationsComponent,
    TermsAndConditionsComponent,
    ContactSupportComponent,
    ArchiveComponent,
    InlineGlossaryComponent,
    ShortTextPipe,
    TableComponent,
    SearchComponent,
    WhatLinksHereComponent,
    EffectiveDateComponent,
    CookieComponent,
    GlossaryTermUsageComponent,
    GlossaryTermTopicComponent,
    HostListenerClickDirective,
    SafeHTMLPipe,
    SourceTracingToolComponent,
    RelatedContentComponent,
    UnderDevelopmentComponent,
    FinalPronouncementComponent,
    SttTableComponent,
    HelpArchivedContentComponent,
    HelpBrowsingComponent,
    HelpBookmarksComponent,
    HelpGlossaryTermFinderComponent,
    HelpMyGarsComponent,
    HelpMyHistoryComponent,
    HelpPrintingComponent,
    HelpRelatedContentComponent,
    HelpSearchingComponent,
    HelpSourceTracingComponent,    
    ImplementationGuideComponent,
    PublicCommentComponent,
    BackButtonComponent,
    AcronymsComponent,
    HelpContactusComponent,
    HelpCopypasteComponent,
    HelpShowallinonepageComponent,
    PdfhelpComponent,
    PdflandingpageComponent,
    AccessManagementComponent,
    AddUserComponent,
    VideosComponent,
    SafePipe,
    ArchiveHomeComponent, RedisCacheManagementComponent,
    PDFBackupLandingPageComponent
  ],
  imports: [
    PublicationModule,
    SharedModule,
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatSliderModule,
    MatGridListModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatCardModule,
    MatToolbarModule,
    MatRadioModule,
    MatFormFieldModule,
    MatSelectModule,
    ReactiveFormsModule,
    FormsModule,
    MatInputModule,
    MatBadgeModule,
    MatSlideToggleModule,
    NgxCaptchaModule,
    MatListModule,
    MatSidenavModule,
    MatExpansionModule,
    MatDialogModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatRadioModule,
    MatPaginatorModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatTabsModule,
    MatCheckboxModule,
    MatAutocompleteModule,
    NgxPrintModule,
    MatProgressSpinnerModule,
    PdfViewerModule,
    MatTreeModule
  ],
  entryComponents: [
    ConfirmDialogComponent
  ],
  providers: [MatNativeDateModule, CommonDataService, ConfigurationService, LoginService, RouteGaurdService, PDFBackupGaurdService, ValidationService, GraphqlService, DatePipe, ClearSessionsService, UtilityService, Title, { provide: HTTP_INTERCEPTORS, useClass: httpInterceptor, multi: true }, InternalViewRouteGuardService, InternalAdminViewRouteGuardService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CacheControlInterceptor,
      multi: true
    }],
  bootstrap: [AppComponent]
})
export class AppModule { }
